// FSSAIStateLicense.jsx
import React from "react";

export default function FSSAIStateLicense() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            FSSAI State License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            FSSAI State License for Food Businesses
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists food businesses in obtaining an FSSAI
            State License in line with state-level regulatory requirements, so
            operations remain compliant and audit-ready.
          </p>
          <p className="text-gray-700">
            From identifying eligibility and preparing Form B to structuring
            supporting documents and coordinating with the State Food Safety
            Department, the process is handled in a streamlined and
            compliance-focused manner.
          </p>
        </div>

        {/* Right: Image (FSSAI State License - Food safety compliance & food manufacturing) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/70497/pexels-photo-70497.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Food safety compliance FSSAI State License food manufacturing"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for FSSAI State License
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps compile and structure all mandatory
              information and proofs required for obtaining an FSSAI State
              License from the respective state authority.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN and identity proof of the applicant or key persons.</li>
                <li>
                  Business registration certificate such as partnership deed,
                  incorporation certificate, or registration under relevant law.
                </li>
                <li>
                  Food safety management details or basic FSMS plan as required
                  under FSSAI norms.
                </li>
                <li>
                  Premises address proof, including rent/lease agreement,
                  ownership papers, or recent utility bill.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers state-specific FSSAI expertise with a strong focus
              on practical compliance, documentation accuracy, and regulatory
              clarity.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  State-wise FSSAI Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance tailored to each state&apos;s FSSAI procedures,
                  eligibility thresholds, and documentation practices so your
                  license aligns with local expectations.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Compliance-Focused Approach
                </h3>
                <p className="text-gray-700 text-sm">
                  A process designed around regulatory compliance, helping
                  reduce the chances of objections, delays, and penalties under
                  the Food Safety and Standards Act.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Regulatory Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end assistance from initial eligibility assessment
                  through online filing, follow-up with authorities, and
                  post-license compliance guidance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
